import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Right Icon
 *
 * @file Right.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Right = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.86377 18.6701L5.26967 14.8477C4.89151 14.4456
        4.91067 13.8127 5.31247 13.4342C5.71426 13.0557
        6.34654 13.0748 6.7247 13.477L9.49147 16.4195L17.1805
        5.42479C17.4969 4.97234 18.1199 4.8623 18.5719
        5.17902C19.0239 5.49573 19.1339 6.11926 18.8174
        6.57171L10.4241 18.5735C10.1077 19.0259 9.48476
        19.1359 9.03274 18.8192C8.96968 18.775 8.91328
        18.7249 8.86377 18.6701Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Right;
